import {IPlanStandardCalculatorClientExtension} from "../../PA.TPM.Core/PA.TPM.IF.TPM.Plan.Aspects";


let PlanStandardCalculatorExtDefault: IPlanStandardCalculatorClientExtension = {

    get id(): string { return "PlanStandardCalculatorExtDefaults" }

}

export {PlanStandardCalculatorExtDefault}